import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$workspaceSlug/dashboard",
      params: { workspaceSlug: params.workspaceSlug },
    });
  },
});
